import actions from './application.actions';

const module = {
  actions: { ...actions },
};

export default module;
